module.exports = __webpack_public_path__ + "img/quickMarkBg.a7e23c7b.png";